export default "__VITE_ASSET__Dj9M1g8L__"